<template>
  <div>
    <b-loading v-model="isLoading" :is-full-page="true"></b-loading>
    <b-modal
      :active="getIsOpenSubscribeModal"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      @close="toggleSubscribeModal(false)"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <b>Unlock More Learning with Up-Skool Plus!</b>
          </p>
        </header>
        <section class="modal-card-body">
          <div class="columns is-multiline">
            <div class="column is-8 flex justify-center">
              <p class="is-title is-5 mb-6">
                <b
                  >Want unlimited access? Subscribe to up-skool Plus for a world
                  of fun learning. 🚀</b
                >
              </p>
              <div class="buttons is-right" style="display:block">
                <b-button class="button is-small is-success" type="button"
                  ><b>Subscribe Now</b></b-button
                >
              </div>
            </div>
            <div class="column is-4 flex justify-center">
              <img :src="require('@/assets/images/growth-subscribe.png')" />
            </div>
          </div>
        </section>
      </div>
    </b-modal>
    <section v-if="fetchCurrentSkill" class="hero is-flex main">
      <bread-crumb :children="breadCrumbs" />
      <!-- <b-button @click="editThisQuestion()" type="is-primary"
        >Edit Question</b-button
      > -->
      <div class="bg-icon star">
        <img src="../assets/images/stars.png" alt="" />
      </div>
      <div v-if="currentQuestion" :key="`QINDEX-${fetchCurrentQuestionIndex}-QID-${currentQuestion._id}`" class="card-container">
        <!--Edit Question Modal-->

        <b-modal
          :active.sync="modalSetQuestionActive"
          has-modal-card
          trap-focus
          :full-screen="true"
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal
          v-if="fetchCurrentSkill"
        >
          <set-question
            :skill_id="fetchCurrentSkill._id"
            :question_id="edit_question_id"
            @over="modalSetQuestionActive = false"
          ></set-question>
        </b-modal>

        <div class="columns">
          <div class="column is-8">
            <div class="left-card" style="overflow: auto;">
              <div
                style="margin-left: 48px; position: relative"
                class="que mb-4"
              >
                <span
                  class="speaker-icon icon"
                  @click="
                    $common.readQuestionLoud(
                      parseText(currentQuestion.question)
                    )
                  "
                  ><img src="../assets/images/speaker.svg" alt=""
                /></span>
                <span class="text"
                  ><quill-view :data="currentQuestion.question"
                /></span>
              </div>

              <div
                v-if="currentQuestion.layers && currentQuestion.layers.length"
                style="margin-left: 48px"
                class="columns is-multiline is-gapless"
              >
                <!-- <span style="position: relative;" class="speaker-icon icon" @click="$common.readQuestionLoud(parseText(currentQuestion.question))"
                ><img src="../assets/images/speaker.svg" alt=""
              /></span> -->
                <show-clipart-layers
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_CLIPART_LAYERS`
                  "
                  :layers="currentQuestion.layers"
                />
              </div>

              <!--Stories Layer-->
              <div
                v-if="currentQuestion.stories && currentQuestion.stories.length"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-story
                  :key="
                    `${currentQuestion._id + fetchCurrentQuestionIndex}_STORY`
                  "
                  :stories="currentQuestion.stories"
                ></show-story>
              </div>

              <!--Tables-->
              <div
                v-if="currentQuestion.tables && currentQuestion.tables.length"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-tables
                  :tables="currentQuestion.tables"
                  :key="
                    `${currentQuestion._id + fetchCurrentQuestionIndex}_TABLES`
                  "
                ></show-tables>
              </div>

              <!--Number Line-->
              <div
                v-if="currentQuestion.number_line"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-number-line
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_NUMBERLINE`
                  "
                  :number_line="currentQuestion.number_line"
                ></show-number-line>
              </div>

              <!--Clock-->
              <div
                v-if="currentQuestion.clock"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-clock
                  :clock="currentQuestion.clock"
                  :key="
                    `${currentQuestion._id + fetchCurrentQuestionIndex}_CLOCK`
                  "
                ></show-clock>
              </div>

              <!--Protractor-->
              <div
                v-if="currentQuestion.protractor"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-protractor
                  :protractor="currentQuestion.protractor"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_PROTRACTOR`
                  "
                ></show-protractor>
              </div>

              <!--Bar Chart-->
              <div
                v-if="currentQuestion.bar_chart"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-bar-chart
                  :bar_chart="currentQuestion.bar_chart"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_BARCHART`
                  "
                ></show-bar-chart>
              </div>

              <!--Line Chart-->
              <div
                v-if="currentQuestion.line_chart"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-line-chart
                  :line_chart="currentQuestion.line_chart"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_LINECHART`
                  "
                ></show-line-chart>
              </div>

              <!--Venn Diagram-->
              <div
                v-if="currentQuestion.venn_diagram"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-venn-diagram
                  :venn_diag="currentQuestion.venn_diagram"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_VENNDIAGRAM`
                  "
                ></show-venn-diagram>
              </div>

              <!--Drag Box-->
              <div
                v-if="
                  currentQuestion.drag_box &&
                    currentQuestion.drag_box.num_rows &&
                    currentQuestion.drag_box.num_columns
                "
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-drag-box
                  :drag_box="currentQuestion.drag_box"
                  :key="
                    `${currentQuestion._id + fetchCurrentQuestionIndex}_DRAGBOX`
                  "
                ></show-drag-box>
              </div>

              <!--Color Grid-->
              <div
                v-if="currentQuestion.color_grid"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-color-grid
                  :color_grid="currentQuestion.color_grid"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_COLOR_GRID`
                  "
                ></show-color-grid>
              </div>

              <!--Line Creator-->
              <div
                v-if="
                  currentQuestion.line_creator &&
                    currentQuestion.line_creator.line_coordinates &&
                    currentQuestion.line_creator.line_coordinates.length
                "
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-line-creator
                  :line_creator="currentQuestion.line_creator"
                ></show-line-creator>
              </div>

              <!--Clipart Table-->
              <div
                v-if="currentQuestion.clipart_table"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-clipart-table
                  :clipart_table="currentQuestion.clipart_table"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_CLIPART_TABLE`
                  "
                ></show-clipart-table>
              </div>

              <!--Clipart Measurement-->
              <div
                v-if="currentQuestion.clipart_measurement"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-clipart-measurement
                  :clipart_measurement="currentQuestion.clipart_measurement"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_CLIPART_MEASUREMENT`
                  "
                ></show-clipart-measurement>
              </div>

              <!--Thermometer-->
              <div
                v-if="currentQuestion.thermometer"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-thermometer
                  :thermometer="currentQuestion.thermometer"
                  :key="
                    `${currentQuestion._id +
                      fetchCurrentQuestionIndex}_THERMOMETER`
                  "
                ></show-thermometer>
              </div>

              <!--Shapes-->
              <div
                v-if="currentQuestion.shapes"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-shapes
                  :is_selectable="currentQuestion.shapes.is_selectable"
                  :shapes="currentQuestion.shapes"
                ></show-shapes>
              </div>

              <!--Ruler-->
              <div
                v-if="currentQuestion.ruler"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-ruler :ruler="currentQuestion.ruler"></show-ruler>
              </div>

              <!--Grid Translator-->
              <div
                v-if="currentQuestion.grid_translator"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-grid-translator
                  :grid_translator="currentQuestion.grid_translator"
                ></show-grid-translator>
              </div>

              <!--Angle Lines-->
              <div
                v-if="currentQuestion.angle_lines"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-angle-lines
                  :angle_lines="currentQuestion.angle_lines"
                ></show-angle-lines>
              </div>

              <!--Cut Spinner-->
              <div
                v-if="currentQuestion.cut_spinner"
                class="mb-2"
                style="margin-left: 48px"
              >
                <show-cut-spinner
                  :cut_spinner="currentQuestion.cut_spinner"
                ></show-cut-spinner>
              </div>

              <div
                style="margin-left: 48px; position: relative"
                class="que mb-4"
                v-if="
                  currentQuestion.question1 &&
                    !currentQuestion.question1_position
                "
              >
                <span
                  class="speaker-icon icon"
                  @click="
                    $common.readQuestionLoud(
                      parseText(currentQuestion.question1)
                    )
                  "
                  ><img src="../assets/images/speaker.svg" alt=""
                /></span>
                <span class="text"
                  ><quill-view :data="currentQuestion.question1"
                /></span>
              </div>

              <div
                v-if="currentQuestion.type == 'DIVIDER'"
                style="margin-left: 48px"
                class="columns is-gapless"
              >
                <div class="column is-12">
                  <show-divider
                    :key="
                      `${currentQuestion._id +
                        fetchCurrentQuestionIndex}_DIVIDER`
                    "
                    :divider="currentQuestion.divider"
                  ></show-divider>
                </div>
              </div>

              <!--Custom Layout-->
              <div
                v-if="
                  currentQuestion.type == 'CL' ||
                    (currentQuestion.mcq &&
                      currentQuestion.mcq.has_custom_layout)
                "
                style="margin-left: 48px"
                class="columns is-gapless"
              >
                <div class="column is-12">
                  <show-custom-layout
                    :key="
                      `${currentQuestion._id +
                        fetchCurrentQuestionIndex}_CL_BOX`
                    "
                    :custom_layout="currentQuestion.custom_layout"
                  ></show-custom-layout>
                </div>
              </div>

              <!--DRAG & DROP-->
              <div
                v-if="currentQuestion.type == 'DRAGDROP'"
                style="padding-left: 48px;width:100%;"
              >
                <div class="columns">
                  <div class="column is-12">
                    <show-drag-drop
                      :drag_drop="currentQuestion.drag_drop"
                      :key="`DRAG_DROP_${currentQuestion._id}`"
                    ></show-drag-drop>
                  </div>
                </div>
              </div>

              <!--PATTERN-->
              <div
                v-if="currentQuestion.type == 'PATTERN'"
                style="margin-left: 48px"
              >
                <show-pattern
                  :pattern="currentQuestion.pattern"
                  :key="
                    `${currentQuestion._id + fetchCurrentQuestionIndex}_PATTERN`
                  "
                ></show-pattern>
              </div>

              <!--For Descriptive-->
              <div
                v-if="currentQuestion.type == 'DQ'"
                class="mt-6 columns is-gapless"
                style="margin-left: 48px"
              >
                <div class="column is-6">
                  <retro-input
                    :key="
                      `${currentQuestion._id + fetchCurrentQuestionIndex}_DQ`
                    "
                    :value="!fetchCurrentAnswer.dq ? '' : fetchCurrentAnswer.dq"
                    placeholder="Add your answer here"
                    @input="getDescriptiveAnswer"
                  ></retro-input>
                </div>
              </div>

              <!--For True/False-->
              <div
                v-else-if="currentQuestion.type == 'TF'"
                class="columns is-gapless is-mobile"
                style="margin-left: 48px"
              >
                <div class="column">
                  <div style="float: left">
                    <focus-button
                      @clicked="trueFalseButtonClicked(true, $event)"
                      text="Yes"
                      :is_clicked="fetchCurrentAnswer.tf == true"
                    ></focus-button>
                  </div>
                  <div style="float: left">
                    <focus-button
                      @clicked="trueFalseButtonClicked(false, $event)"
                      text="No"
                      :is_clicked="fetchCurrentAnswer.tf == false"
                    ></focus-button>
                  </div>
                </div>
              </div>

              <!--For MCQ-->
              <show-mcq
                v-else-if="currentQuestion.type == 'MCQ'"
                :mcq="currentQuestion.mcq"
                :key="`${currentQuestion._id + fetchCurrentQuestionIndex}_MCQ`"
              ></show-mcq>

              <!--For ORDERING-->
              <div
                v-else-if="currentQuestion.type == 'ORDERING'"
                ref="mcq-quiz-show"
                class="columns is-gapless is-multiline"
                style="margin-left: 46px; position: relative"
              >
                <div
                  style="position: relative"
                  class="column is-12 mb-2 is-flex"
                >
                  <sortable
                    v-for="(option, option_index) in currentQuestion.ordering
                      .options"
                    v-model="dragData"
                    :key="
                      `${currentQuestion._id +
                        fetchCurrentQuestionIndex}_ORDERING_OPTION_${option_index}`
                    "
                    :index="option_index"
                    drag-direction="horizontal"
                    replace-direction="horizontal"
                    @sortend="
                      $common.sortend($event, currentQuestion.ordering.options)
                    "
                  >
                    <focus-button
                      :text="option.is_hide_label ? '' : option.name"
                      :layers="option.layers"
                      :is_clicked="false"
                      :clicked_state="false"
                      :display_type="
                        option.option_type ? option.option_type : 'D'
                      "
                      :custom_width="option.custom_width"
                      :styles="option.styles"
                      :custom_layout="option.custom_layout"
                      :clock="option.clock"
                      :protractor="option.protractor"
                      :bar_chart="option.bar_chart"
                      :line_chart="option.line_chart"
                      :number_line="option.number_line"
                      :shapes="option.shapes"
                    ></focus-button>
                  </sortable>
                </div>
              </div>

              <!--Matching-->
              <div
                v-if="currentQuestion.type == 'MATCHING'"
                style="margin-left: 48px; width: 85%; min-width: 600px"
              >
                <show-matching
                  :matching="currentQuestion.matching"
                ></show-matching>
              </div>

              <div
                style="margin-left: 48px; position: relative"
                class="que mb-4"
                v-if="
                  currentQuestion.question1 &&
                    currentQuestion.question1_position == 'after1'
                "
              >
                <span
                  class="speaker-icon icon"
                  @click="
                    $common.readQuestionLoud(
                      parseText(currentQuestion.question1)
                    )
                  "
                  ><img src="../assets/images/speaker.svg" alt=""
                /></span>
                <span class="text"
                  ><quill-view :data="currentQuestion.question1"
                /></span>
              </div>
              <hr />
              <bottom-navigator :currentQuestion="currentQuestion" />
            </div>
          </div>
          <div class="column is-4">
            <div class="right-card">
              <live-statistics :currentQuestionId="currentQuestion._id" />
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SetQuestion from "@/components/Question/SetQuestion";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Sortable from "vue-drag-sortable";
import ShowClipartLayers from "@/components/Question/Clipart/ShowClipartLayers";
import LiveStatistics from "@/components/Quiz/LiveStatistics";
import BottomNavigator from "@/components/Quiz/BottomNavigator";
import ShowCustomLayout from "@/components/Question/CustomLayout/ShowCustomLayout";
import ShowDragDrop from "@/components/Question/ShowDragDrop";
import ShowPattern from "@/components/Question/ShowPattern";
import ShowTables from "@/components/Question/ShowTables";
import ShowStory from "@/components/Question/ShowStory";
import ShowNumberLine from "@/components/Question/NumberLine/ShowNumberLine";
import ShowClock from "@/components/Question/Clock/ShowClock";
import ShowProtractor from "@/components/Question/Protractor/ShowProtractor";
import ShowDivider from "@/components/Question/ShowDivider";
import ShowMatching from "@/components/Question/Matching/ShowMatching";
import ShowBarChart from "@/components/Question/Charts/ShowBarChart";
import ShowLineChart from "@/components/Question/Charts/ShowLineChart";
import ShowVennDiagram from "@/components/Question/VeinnDiagram/ShowVennDiagram";
import ShowDragBox from "@/components/Question/DragBox/ShowDragBox";
import ShowColorGrid from "@/components/Question/ColorGrid/ShowColorGrid";
import ShowGridTranslator from "@/components/Question/GridTranslator/ShowGridTranslator";
import ShowLineCreator from "@/components/Question/LineCreator/ShowLineCreator";
import ShowCutSpinner from "@/components/Question/CutSpinner/ShowCutSpinner";
import ShowAngleLines from "@/components/Question/AngleLines/ShowAngleLines";
import ShowClipartTable from "@/components/Question/ClipartTable/ShowClipartTable";
import ShowClipartMeasurement from "@/components/Question/ClipartMeasurement/ShowClipartMeasurement";
import ShowThermometer from "@/components/Question/Thermometer/ShowThermometer";
import ShowShapes from "@/components/Question/Shapes/ShowShapes";
import ShowRuler from "@/components/Question/Ruler/ShowRuler";
import ShowMcq from "@/components/Question/MCQ/ShowMcq";
// import RetroButton from '@/components/RetroButton'
import RetroInput from "@/components/RetroInput";
import FocusButton from "@/components/FocusButton";
import QuillView from "@/components/Editor/QuillView";

export default {
  name: "Quiz",
  refs: ["custom_layout_outer_box"],
  components: {
    SetQuestion,
    BreadCrumb,
    QuillView,
    LiveStatistics,
    BottomNavigator,
    ShowCustomLayout,
    ShowDragDrop,
    ShowPattern,
    ShowTables,
    ShowStory,
    ShowNumberLine,
    ShowClock,
    ShowProtractor,
    ShowDivider,
    RetroInput,
    FocusButton,
    Sortable,
    ShowMatching,
    ShowBarChart,
    ShowLineChart,
    ShowVennDiagram,
    ShowDragBox,
    ShowColorGrid,
    ShowGridTranslator,
    ShowCutSpinner,
    ShowClipartTable,
    ShowClipartMeasurement,
    ShowThermometer,
    ShowShapes,
    ShowRuler,
    ShowAngleLines,
    ShowLineCreator,
    ShowClipartLayers,
    ShowMcq,
  },
  props: {
    kid_id: {
      type: String,
      required: true,
    },
    grade_subject_id: {
      type: String,
      required: true,
    },
    category_id: {
      type: String,
      required: true,
    },
    skill_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dragData: {},
      isLoading: false,
      modalSetQuestionActive: false,
      edit_question_id: null,
    };
  },
  mounted: function() {
    // Adding 1000 milliseconds delay because we cannot catch child component mounted hook
    this.$nextTick(() => {
      setTimeout(function() {
        document.getElementsByTagName("input")[0]?.focus();
      }, 1000);
    });
  },
  methods: {
    ...mapActions([
      "loadQuestions",
      "loadCategoryDetails",
      "loadSkillDetails",
      "updateCurrentAnswer",
      "initializeCurrentAnswer",
      "clearQuestionResponseMappings",
      "updateCurrentQuestionIndex",
      "toggleSubscribeModal",
      "toggleFreeLimitReached",
      "loadKidDetails",
    ]),
    editThisQuestion() {
      this.edit_question_id = this.currentQuestion._id;
      this.modalSetQuestionActive = true;
    },
    async speakMCQ() {
      if (this.currentQuestion.mcq?.allow_reading_options) {
        const nodes = this.$refs["mcq-quiz-show"].querySelectorAll(
          ".button-3d, .simple-2d"
        );
        const mcq_options = this.currentQuestion.mcq.options.map((o) => o.name);
        for (let i in mcq_options) {
          const oldColor = nodes[i].style.backgroundColor;
          nodes[i].style.backgroundColor = "#21ff11";
          await this.$common.readQuestionLoud(mcq_options[i]);
          nodes[i].style.backgroundColor = oldColor;
        }
      }
    },
    parseText(html) {
      let tempDivElement = document.createElement("div");
      tempDivElement.innerHTML = html;
      return tempDivElement.textContent || tempDivElement.innerText || "";
    },
    currentRowOptions(options, row_no) {
      return options.slice(
        (row_no - 1) * this.optionButtonsEachRow,
        row_no * this.optionButtonsEachRow
      );
    },
    getDescriptiveAnswer(input) {
      // For descriptive question
      this.updateCurrentAnswer({
        key: "dq",
        value: input,
      });
    },
    trueFalseButtonClicked(type, clicked_state) {
      if (clicked_state) {
        this.updateCurrentAnswer({
          key: "tf",
          value: type,
        });
      }
    },
    optionClicked(option_index, row_index, clicked_state) {
      let response_index =
        (row_index - 1) * this.optionButtonsEachRow + option_index;
      //Add option index to current answer

      if (clicked_state) {
        //If type is single answer mcq then remove all responses first
        if (this.currentQuestion.mcq.type == "S") {
          this.updateCurrentAnswer({
            key: "options",
            value: [],
          });
        }

        this.updateCurrentAnswer({
          key: "options",
          value: [...this.fetchCurrentAnswer.options, response_index],
        });
      } else {
        this.updateCurrentAnswer({
          key: "options",
          value: this.fetchCurrentAnswer.options.filter(
            (answer) => answer != response_index
          ),
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "getUserType",
      "getTeacherToken",
      "fetchCurrentQuestionIndex",
      "fetchQuestions",
      "fetchColors",
      "fetchCurrentSkill",
      "fetchEmptyAnswerState",
      "fetchCurrentAnswer",
      "getIsOpenSubscribeModal",
      "fetchCurrentCategory",
      "fetchCurrentKid",
    ]),
    breadCrumbs() {
      if (
        this.fetchCurrentKid &&
        this.fetchCurrentCategory &&
        this.fetchCurrentSkill
      ) {
        return [
          {
            title: this.fetchCurrentKid.name,
            url: `/kid/${this.kid_id}/practice`,
          },
          {
            title: `${this.fetchCurrentCategory.grade_subject.grade.name} ${this.fetchCurrentCategory.grade_subject.subject.name}`,
            url: `/kid/${this.kid_id}/practice/${this.grade_subject_id}/category`,
          },
          {
            title: `${this.fetchCurrentCategory.name}`,
            url: `/kid/${this.kid_id}/practice/${this.grade_subject_id}/category/${this.category_id}/skill`,
          },
          {
            title: `${this.fetchCurrentSkill.name}`,
            url: window.location.href,
          },
        ];
      }

      return [];
    },
    optionButtonsEachRow() {
      let no = 5;
      if (
        this.currentQuestion.type == "MCQ" &&
        this.currentQuestion.mcq.option_buttons_each_row
      ) {
        no = this.currentQuestion.mcq.option_buttons_each_row;
      }
      return no;
    },
    currentQuestion() {
      //Returns current Question
      return this.fetchQuestions[this.fetchCurrentQuestionIndex];
    },
  },
  watch: {
    fetchCurrentQuestionIndex: function() {
      //Checking if this question is already answered
      this.initializeCurrentAnswer();

      setTimeout(function() {
        document.getElementsByTagName("input")[0]?.focus();
      }, 1000);
    },
  },
  created() {
    this.toggleFreeLimitReached(false);
    this.toggleSubscribeModal(false);
    this.isLoading = true;
    const firstQuestionId = this.$route.query.first_question;
    
      Promise.all([
        this.loadKidDetails({
          token: this.getTeacherToken,
          id: this.kid_id,
        }),
        this.clearQuestionResponseMappings(),

        this.updateCurrentQuestionIndex(0),

        this.loadSkillDetails({
          token: this.getTeacherToken,
          id: this.skill_id,
        }),

        this.loadCategoryDetails({
          token: this.getTeacherToken,
          id: this.category_id,
        }),

        this.loadQuestions({
          token: this.getTeacherToken,
          filter: {
            skill: this.skill_id,
          },
          options: {
            firstQuestionId,
          },
        }),
      ]).catch((err) => {
        console.log(err);
        this.$buefy.toast.open({
          message: err.response.data,
          type: "is-danger",
        });
      }).finally(() => {
        this.isLoading = false;
      });
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.speaker-icon {
  position: absolute;
  left: -48px;
}
.title {
  font-size: 3vw;
  margin: 0 !important;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.link {
  cursor: pointer;
}
.main {
  align-items: center;
  margin: 0vw 0vw;
  position: relative;
  gap: 2.4vw;
}
/* responsive page*/
/* tablet */
@media screen and (max-width: 1023px) {
  .title {
    font-size: 3.5vw !important;
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .title {
    font-size: 4vw !important;
  }
  
  .main {
    margin: 0 !important;
  }
}

@media screen and (max-width: 480px) {
  .main {
    margin: 0 !important;
  }
}

@media screen and (max-width: 467px) {
  .title {
    font-size: 5vw !important;
  }
}

@media screen and (max-width: 360px) {
  .main {
    margin: 0 !important;
  }
}

.bg-icon {
  position: absolute;
}

.star {
  left: 77vw;
  top: -1vw;
  max-width: 5vw;
}

.main {
  align-items: center;
  margin-top: 2vw;
  position: relative;
  gap: 2.4vw;
}
.main .card-container {
  width: 100%;
}
.main .card-container .left-card,
.main .card-container .right-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 3.6vw 2vw;
  border-radius: 1.8vw;
}
.main .card-container .left-card {
  background: rgba(137, 25, 231, 0.1);
  justify-content: flex-start;
}
.main .card-container .left-card .que {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main .card-container .left-card .que span.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
}
.main .card-container .left-card .que span.text {
  font-weight: 600;
  font-size: 20px;
  color: #000000;
  font-family: "Source Sans Pro", sans-serif;
}
.main .card-container .left-card .img-container {
  padding: 3.8vw 2.6vw;
  display: flex;
  flex-direction: column;
  gap: 3.6vw;
}
.main .card-container .left-card .img-container img {
  max-width: 10vw;
}
.main .card-container .right-card {
  background: rgba(49, 200, 255, 0.0784313725);
  padding: 20px;
  justify-content: flex-start;
}
.main .card-container .right-card .inner-card {
  display: flex;
  width: 75%;
  align-items: center;
  background: #fff;
  position: relative;
}
.main .card-container .right-card .inner-card .svg {
  position: relative;
  right: 12%;
  max-width: 6vw;
}
.main .card-container .right-card .inner-card .inner-card-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.6vw;
}
.main .card-container .right-card .inner-card .inner-card-content .text,
.main .card-container .right-card .inner-card .inner-card-content div {
  font-weight: 600;
}
.main .card-container .right-card .inner-card .inner-card-content .text {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #000000;
}
.main .card-container .right-card .inner-card .inner-card-content div {
  display: flex;
  gap: 0.6vw;
}
.main .card-container .right-card .inner-card .inner-card-content div span {
  color: #31c7ff;
}
.main .card-container .right-card .bg-icon {
  position: absolute;
  right: -4.2vw;
  bottom: -2.5vw;
  max-width: 17.6vw;
}

@media screen and (max-width: 767px) {
  .main .card-container {
    flex-direction: column;
  }
  .main .card-container .right-card .svg {
    right: 5% !important;
  }
  .title {
    font-size: 3.5vw !important;
  }
}
.drag-sortable {
  float: left;
}

hr {
  margin: 0.5rem 0 !important;
}

.modal {
  z-index: 501;
}

/* Custom Scrollbar for all screens */
.left-card::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
}

.left-card::-webkit-scrollbar-track {
  background: linear-gradient(180deg, rgba(137, 25, 231, 0.1) 0%, rgba(114, 9, 183, 0.1) 100%);
  border-radius: 10px;
}

.left-card::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #8919e7 0%, #7209b7 50%, #6f10bf 100%);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: 0 2px 8px rgba(137, 25, 231, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 8px rgba(137, 25, 231, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.left-card::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #9c2bff 0%, #8019d4 50%, #7209b7 100%);
  -webkit-box-shadow: 0 4px 12px rgba(137, 25, 231, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(137, 25, 231, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.left-card::-webkit-scrollbar-thumb:active {
  background: linear-gradient(180deg, #7209b7 0%, #6f10bf 50%, #5d0e9f 100%);
  -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Preserve whitespace in question display */
.que .text,
.que .text p,
.que .text div {
  white-space: pre-wrap;
}
</style>
